import { useEffect } from 'react';
import { Link } from 'react-router-dom';

/* ─── Palette & tokens ───────────────────────────────────────────── */
const C = {
  royal: '#1A2E8F',
  marine: '#0D1F6E',
  dark: '#0B184F',
  gold: '#F5C842',
  goldLight: '#ffd866',
  white: '#FFFFFF',
  cream: '#F7F4EE',
  text: '#1C1C2E',
  muted: '#5A5A7A',
};

/* ─── DATA — Piliers ─────────────────────────────────────────────── */
const piliers = [
  {
    numero: '01',
    icone: 'healing',
    couleur: '#E8F5E9',
    accentCouleur: '#2E7D32',
    titre: 'Santé',
    sousTitre: 'Soigner par la nature et la sagesse ancestrale',
    description:
      'FONDASYON FELICITEE cultive un jardin de plantes médicinales qui soigne les personnes souffrantes selon les savoirs thérapeutiques ayitiens. Nous enseignons à nos communautés comment utiliser ces plantes pour une autonomie sanitaire préservée.',
    programmes: ['Jardin de plantes médicinales', 'KOMSEMAKTO — Connaissance de soi'],
  },
  {
    numero: '02',
    icone: 'balance',
    couleur: '#FFF3E0',
    accentCouleur: '#E65100',
    titre: 'Justice',
    sousTitre: 'Défendre la dignité de chaque génération',
    description:
      'Nous prônons une éducation impérative en matière de justice. Nous nettoyons, réparons et entretenons les tombes et statues de nos Ancêtres là où les responsables n\'assurent pas leurs obligations. Nous soutenons les centenaires dans leur dignité quotidienne.',
    programmes: ['KOMALFA — Alphabétisation', 'KOMFESAY — Soutien aux centenaires', 'KOMSEMAKTO — Connaissance de soi'],
  },
  {
    numero: '03',
    icone: 'school',
    couleur: '#E3F2FD',
    accentCouleur: '#1565C0',
    titre: 'Éducation',
    sousTitre: 'Transmettre la mémoire, éveiller les consciences',
    description:
      'Notre mission centrale : populariser l\'histoire des enfants d\'Afrika/Meritah/Alkebulan à travers divers médias. De l\'alphabétisation à la recherche historique, en passant par la galerie patrimoniale, nous construisons des ponts entre mémoire ancestrale et futur.',
    programmes: ['KOMALFA — Lire & écrire', 'KOMRISTORICH — Richesse historique', 'KOMRSL — Rencontres histoire', 'KOMSEMAKTO — Connaissance de soi', 'Galerie des Aïeules et Aïeux'],
  },
  {
    numero: '04',
    icone: 'trending_up',
    couleur: '#F3E5F5',
    accentCouleur: '#6A1B9A',
    titre: 'Prospérité',
    sousTitre: 'Forger les entrepreneurs et bâtisseurs de demain',
    description:
      'Nous considérons la prospérité comme partie intégrante de la santé et de la justice. Sans elle, la paix ne peut s\'épanouir. KOMJKT encourage les jeunes à l\'entrepreneuriat pour construire des bases économiques solides au sein de la diaspora haïtienne.',
    programmes: ['KOMJKT — Entrepreneuriat jeunesse', 'KOMSEMAKTO — Connaissance de soi'],
  },
];

/* ─── DATA — Comités ─────────────────────────────────────────────── */
const comites = [
  { sigle: 'KOMALFA', nom: 'Comité Alphabétisation', description: 'Apprendre à lire et à écrire pour libérer la pensée et ouvrir l\'horizon des communautés.' },
  { sigle: 'KOMFESAY', nom: 'Comité des Centenaires', description: 'Honorer et soutenir nos aînés de 100 ans et plus dans leur dignité, leur nutrition et leur confort quotidien.' },
  { sigle: 'KOMJKT', nom: 'Comité Entrepreneuriat', description: 'Encourager et accompagner les jeunes vers l\'entrepreneuriat pour bâtir des bases économiques durables.' },
  { sigle: 'KOMRISTORICH', nom: 'Richesse Historique', description: 'Recherche et diffusion de la richesse historique et traditionnelle de notre patrimoine ancestral africain et haïtien.' },
  { sigle: 'KOMRSL', nom: 'Rencontres sur l\'Histoire', description: 'Organiser des rencontres et débats pour partager, célébrer et transmettre notre histoire collective vivante.' },
  { sigle: 'KOMSEMAKTO', nom: 'Connaissance de Soi', description: 'Formation sur la connaissance de soi comme fondement d\'une identité forte et d\'une action collective ancrée.' },
  { sigle: 'KOMÒDINA', nom: 'Coordination Administrative', description: 'Gestion des présences, des activités et du personnel pour assurer le bon fonctionnement de la fondation.' },
  { sigle: 'GALERIE', nom: 'Galerie des Aïeules et Aïeux', description: 'Numérisation et exposition des archives photographiques et documents précieux de nos ancêtres fondateurs.' },
];

/* ─── COMPOSANT PRINCIPAL ────────────────────────────────────────── */
export default function LaFondasyon() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen overflow-x-hidden bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
      <style>{`
        .font-script { font-family: 'Dancing Script', cursive; }
        .font-montserrat { font-family: 'Montserrat', sans-serif; }
        .material-symbols-outlined { font-variation-settings:'FILL' 0,'wght' 400; }
        /* Timeline */
        .timeline-item::before { content:''; position:absolute; left:-1px; top:0; bottom:0; width:2px; background:linear-gradient(to bottom,#F5C842,#1A2E8F); }
        /* Pilier card hover */
        .pilier-card { transition:all .4s cubic-bezier(.4,0,.2,1); }
        .pilier-card:hover { transform:translateY(-8px); box-shadow:0 24px 48px rgba(26,46,143,.12); }
        /* Comité card */
        .comite-card { transition:all .35s ease; }
        .comite-card:hover { background:#1A2E8F; }
        .comite-card:hover .comite-sigle { color:#F5C842; }
        .comite-card:hover .comite-titre,.comite-card:hover .comite-desc { color:#fff; }
        /* Scroll reveal */
        @keyframes fadeUp { from{opacity:0;transform:translateY(32px)} to{opacity:1;transform:translateY(0)} }
        .fade-up { animation:fadeUp .7s ease-out forwards; }
        /* Gold bar */
        .gold-bar { background:linear-gradient(90deg,#F5C842,#ffd866); }
        /* Hero overlay */
        .hero-overlay { background:linear-gradient(135deg,rgba(11,24,79,.92) 0%,rgba(26,46,143,.75) 60%,rgba(26,46,143,.2) 100%); }
        /* Invite quote */
        .invite-bg { background:linear-gradient(135deg,#0D1F6E 0%,#1A2E8F 100%); }
        /* Nombre géant */
        .giant-num { font-size:clamp(80px,12vw,160px); line-height:1; font-family:'Montserrat',sans-serif; font-weight:900; color:rgba(245,200,66,.12); user-select:none; position:absolute; right:-20px; top:-10px; }
      `}</style>

      {/* ═══════════════════════════════════════════════════════════
          HERO — ÉDITORIAL MAGAZINE PLEIN ÉCRAN
      ═══════════════════════════════════════════════════════════ */}
      <section className="relative min-h-[92vh] flex items-end overflow-hidden">
        {/* Image de fond */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=1920&q=85"
            alt="Patrimoine haïtien"
            className="w-full h-full object-cover"
          />
          <div className="hero-overlay absolute inset-0"></div>
        </div>

        {/* Ligne dorée verticale décorative */}
        <div className="absolute left-8 top-0 bottom-0 w-[2px] z-10 hidden lg:block" style={{ background: 'linear-gradient(to bottom, transparent, #F5C842 30%, #F5C842 70%, transparent)' }}></div>

        {/* Contenu hero */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-16 pb-20 pt-40">
          <div className="max-w-4xl fade-up">
            {/* Breadcrumb */}
            <div className="flex items-center gap-3 mb-8">
              <Link to="/" className="text-white/50 hover:text-white text-xs font-montserrat uppercase tracking-widest transition-colors">Accueil</Link>
              <span className="text-[#F5C842] text-xs">→</span>
              <span className="text-[#F5C842] text-xs font-montserrat uppercase tracking-widest">La Fondasyon</span>
            </div>

            {/* Étiquette */}
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-[2px] gold-bar"></div>
              <span className="text-[#F5C842] font-montserrat font-bold text-xs uppercase tracking-[0.4em]">Fondée en 1999 · Haïti & USA</span>
            </div>

            {/* Titre principal */}
            <h1 className="font-montserrat font-black text-white uppercase leading-[0.95] mb-8" style={{ fontSize: 'clamp(52px, 8vw, 110px)', letterSpacing: '-0.03em' }}>
              La<br /><span style={{ color: '#F5C842' }}>Fondasyon</span>
            </h1>

            {/* Sous-titre éditorial */}
            <p className="text-white/85 text-xl lg:text-2xl max-w-2xl leading-relaxed mb-12" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>
              "Gardiens de la mémoire ancestrale d'Ayiti, bâtisseurs d'un avenir digne pour tous les enfants d'Alkebulan."
            </p>

            {/* Trois métriques */}
            <div className="grid grid-cols-3 gap-6 max-w-xl">
              {[{ n: '1999', l: 'Année de\nfondation' }, { n: '+25', l: "Années\nd'impact" }, { n: '2021', l: 'Chapitre\nUSA' }].map((m, i) => (
                <div key={i} className="border-l-2 border-[#F5C842] pl-4">
                  <div className="text-3xl font-montserrat font-black text-white">{m.n}</div>
                  <div className="text-white/60 text-xs uppercase tracking-wider whitespace-pre-line leading-tight mt-1">{m.l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 right-8 z-10 flex flex-col items-center gap-2 opacity-60">
          <span className="text-white text-[10px] uppercase tracking-widest font-montserrat" style={{ writingMode: 'vertical-rl' }}>Découvrir</span>
          <div className="w-[1px] h-16 bg-gradient-to-b from-white to-transparent"></div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════
          BANDE D'INVITATION — "SANKOFA"
      ═══════════════════════════════════════════════════════════ */}
      <section className="invite-bg py-16 relative overflow-hidden">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(rgba(245,200,66,.07) 1px, transparent 1px)', backgroundSize: '24px 24px' }}></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            {[
              { n: '1', titre: 'SANKOFA', texte: 'Sachez ce que vous aviez accompli avant' },
              { n: '2', titre: 'MAINTENANT', texte: 'Apprenez à savoir qui vous êtes' },
              { n: '3', titre: 'DEMAIN', texte: 'Vous saurez la puissance qui sommeille dans votre âme' },
            ].map((item, i) => (
              <div key={i} className="flex flex-col items-center">
                <div className="w-10 h-10 rounded-full border-2 border-[#F5C842] flex items-center justify-center font-montserrat font-black text-[#F5C842] text-lg mb-4">{item.n}</div>
                <h3 className="font-montserrat font-black text-white text-sm uppercase tracking-[0.2em] mb-2">{item.titre}</h3>
                <p className="text-white/65 text-sm leading-relaxed max-w-xs">{item.texte}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════
          MISSION & VISION — LAYOUT ASYMÉTRIQUE
      ═══════════════════════════════════════════════════════════ */}
      <section className="py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-16">

          {/* MISSION */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-28">
            {/* Visuel gauche */}
            <div className="relative">
              <div className="aspect-[4/5] overflow-hidden rounded-2xl shadow-2xl">
                <img src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=800&q=80" alt="Mission FF" className="w-full h-full object-cover" />
              </div>
              {/* Badge flottant */}
              <div className="absolute -bottom-6 -right-6 bg-[#F5C842] p-6 rounded-2xl shadow-xl max-w-[200px]">
                <span className="material-symbols-outlined text-[#1A2E8F] text-4xl mb-2 block">volunteer_activism</span>
                <div className="font-montserrat font-black text-[#1A2E8F] text-sm uppercase leading-tight">501(c)(3)<br/>Reconnue USA</div>
              </div>
            </div>

            {/* Texte droite */}
            <div className="lg:pl-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-8 h-[3px] gold-bar rounded-full"></div>
                <span className="text-[#F5C842] font-montserrat font-bold text-xs uppercase tracking-[0.35em]">Notre Mission</span>
              </div>
              <h2 className="font-montserrat font-black text-[#1A2E8F] uppercase leading-tight mb-8" style={{ fontSize: 'clamp(36px, 4.5vw, 64px)', letterSpacing: '-0.02em' }}>
                Populariser<br />l'histoire.<br /><span style={{ color: '#F5C842', WebkitTextStroke: '2px #F5C842', WebkitTextFillColor: 'transparent' }}>Transformer</span><br />la mémoire.
              </h2>
              <div className="space-y-5 text-[#5A5A7A] leading-relaxed text-base">
                <p>
                  <strong className="text-[#1C1C2E]">FONDASYON FELICITEE, INC.</strong> se consacre à populariser l'histoire des enfants d'Afrika/Meritah/Alkebulan à travers divers médias. Notre perception historique inclut les contributions de toutes les formes de vie à l'évolution de l'humanité.
                </p>
                <p>
                  Nous savons que les actions sont plus éloquentes que les mots, c'est pourquoi nous nettoyons, réparons et entretenons les tombes et statues de nos Ancêtres là où les responsables n'assurent pas leurs obligations.
                </p>
                <p>
                  L'une des façons que nous honorons nos aînés c'est en soutenant les personnes âgées de 100 ans et plus, en leur procurant de quoi vivre dans la dignité et le respect.
                </p>
              </div>

              {/* Tags piliers */}
              <div className="flex flex-wrap gap-2 mt-8">
                {['Santé', 'Justice', 'Éducation', 'Prospérité'].map((t) => (
                  <span key={t} className="px-4 py-2 border-2 border-[#1A2E8F] text-[#1A2E8F] font-montserrat font-bold text-xs uppercase tracking-wider rounded-full">{t}</span>
                ))}
              </div>
            </div>
          </div>

          {/* VISION */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Texte gauche */}
            <div className="lg:pr-8 order-2 lg:order-1">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-8 h-[3px] gold-bar rounded-full"></div>
                <span className="text-[#F5C842] font-montserrat font-bold text-xs uppercase tracking-[0.35em]">Notre Vision</span>
              </div>
              <h2 className="font-montserrat font-black text-[#1A2E8F] uppercase leading-tight mb-8" style={{ fontSize: 'clamp(36px, 4.5vw, 64px)', letterSpacing: '-0.02em' }}>
                Un monde où<br />l'héritage est<br /><span style={{ color: '#F5C842' }}>célébré.</span>
              </h2>
              <div className="space-y-5 text-[#5A5A7A] leading-relaxed text-base">
                <p>
                  <strong className="text-[#1C1C2E]">FONDASYON FELICITEE, INC.</strong> envisage un monde où les contributions de toutes les formes de vie à l'évolution de l'humanité sont reconnues et célébrées.
                </p>
                <p>
                  FF aspire à créer une société où notre histoire est partagée à travers divers médias, favorisant une compréhension et une appréciation plus profondes de notre patrimoine collectif.
                </p>
                <p>
                  Ensemble, nous nous efforçons de créer un héritage de changement positif qui transcende les générations. FF perçoit Haïti comme le projet pilote qui se mettra au service de tous ceux qui ont souffert du Maafa.
                </p>
              </div>
            </div>

            {/* Visuel droite */}
            <div className="relative order-1 lg:order-2">
              <div className="aspect-[4/5] overflow-hidden rounded-2xl shadow-2xl">
                <img src="https://images.unsplash.com/photo-1531206715517-5c0ba140b2b8?w=800&q=80" alt="Vision FF" className="w-full h-full object-cover" />
              </div>
              {/* Citation flottante */}
              <div className="absolute -bottom-6 -left-6 bg-[#1A2E8F] p-6 rounded-2xl shadow-xl max-w-[240px]">
                <p className="text-[#F5C842] font-script text-lg leading-snug mb-2">"Construire un héritage qui transcende les générations."</p>
                <div className="w-6 h-[1px] bg-[#F5C842] mb-2"></div>
                <span className="text-white/60 text-[10px] uppercase tracking-widest font-montserrat">FONDASYON FELICITEE</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════
          LES 4 PILIERS — GRILLE ÉDITORIALE
      ═══════════════════════════════════════════════════════════ */}
      <section className="py-28" style={{ background: C.cream }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-16">
          {/* En-tête section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-end mb-20">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-8 h-[3px] gold-bar rounded-full"></div>
                <span className="text-[#F5C842] font-montserrat font-bold text-xs uppercase tracking-[0.35em]">Architecture de la fondation</span>
              </div>
              <h2 className="font-montserrat font-black text-[#1A2E8F] uppercase leading-tight" style={{ fontSize: 'clamp(36px, 5vw, 72px)', letterSpacing: '-0.02em' }}>
                Les 4<br />Piliers
              </h2>
            </div>
            <p className="text-[#5A5A7A] text-lg leading-relaxed">
              FONDASYON FELICITEE sait qu'en l'absence de la santé, de la justice, de l'éducation et de la prospérité, la paix ne peut pas s'épanouir. Ces quatre piliers structurent chacune de nos actions.
            </p>
          </div>

          {/* Grille des piliers */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {piliers.map((p, i) => (
              <div key={i} className="pilier-card bg-white rounded-2xl p-8 shadow-sm relative overflow-hidden cursor-default">
                {/* Numéro géant de fond */}
                <div className="giant-num">{p.numero}</div>

                <div className="relative z-10">
                  {/* Icône + numéro */}
                  <div className="flex items-start justify-between mb-6">
                    <div className="w-14 h-14 rounded-xl flex items-center justify-center" style={{ background: p.couleur }}>
                      <span className="material-symbols-outlined text-3xl" style={{ color: p.accentCouleur }}>{p.icone}</span>
                    </div>
                    <span className="font-montserrat font-black text-[#1A2E8F]/10 text-5xl leading-none">{p.numero}</span>
                  </div>

                  {/* Titre */}
                  <div className="mb-1">
                    <span className="font-montserrat font-black text-[#1A2E8F] text-3xl uppercase">{p.titre}</span>
                  </div>
                  <p className="font-script text-[#F5C842] text-lg mb-4">{p.sousTitre}</p>
                  <div className="w-10 h-[2px] gold-bar mb-5"></div>

                  {/* Description */}
                  <p className="text-[#5A5A7A] text-sm leading-relaxed mb-6">{p.description}</p>

                  {/* Programmes */}
                  <div className="flex flex-wrap gap-2">
                    {p.programmes.map((prog, j) => (
                      <span key={j} className="px-3 py-1 rounded-full text-[11px] font-montserrat font-bold uppercase tracking-wider"
                        style={{ background: p.couleur, color: p.accentCouleur }}>
                        {prog}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════
          HISTORIQUE — TIMELINE VERTICALE
      ═══════════════════════════════════════════════════════════ */}
      <section className="py-28 bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-16">
          <div className="text-center mb-20">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="w-8 h-[3px] gold-bar rounded-full"></div>
              <span className="text-[#F5C842] font-montserrat font-bold text-xs uppercase tracking-[0.35em]">Notre parcours</span>
              <div className="w-8 h-[3px] gold-bar rounded-full"></div>
            </div>
            <h2 className="font-montserrat font-black text-[#1A2E8F] uppercase" style={{ fontSize: 'clamp(32px, 5vw, 64px)', letterSpacing: '-0.02em' }}>
              25 Ans d'Histoire
            </h2>
          </div>

          {/* Timeline */}
          <div className="relative pl-8 border-l-2 border-[#F5C842]/30 space-y-14">
            {[
              {
                annee: '1999',
                titre: 'Naissance de FONDASYON FELICITEE',
                texte: 'Création à Ayiti d\'une organisation dédiée à la préservation de la mémoire ancestrale et au soutien des communautés haïtiennes. Les fondateurs posent les bases d\'une institution culturelle enracinée dans les principes d\'Ubuntu.',
                icone: 'flag',
              },
              {
                annee: '2000–2010',
                titre: 'Premiers programmes communautaires',
                texte: 'Lancement des premières initiatives : alphabétisation (KOMALFA), soutien aux centenaires (KOMFESAY), nettoyage et entretien des tombes ancestrales. La Galerie des Aïeules et Aïeux commence à numériser les archives.',
                icone: 'groups',
              },
              {
                annee: '2010–2020',
                titre: 'Expansion des axes de fonctionnement',
                texte: 'Structuration autour des 4 piliers. Création du jardin de plantes médicinales, lancement de KOMRISTORICH pour la recherche historique, et de KOMJKT pour encourager l\'entrepreneuriat des jeunes de la diaspora.',
                icone: 'account_tree',
              },
              {
                annee: '2021',
                titre: 'Chapitre officiel aux États-Unis',
                texte: 'FONDASYON FELICITEE obtient le statut 501(c)(3) et ouvre officiellement son chapitre américain pour amplifier son impact auprès de la diaspora haïtienne établie aux États-Unis. Organisation de la Soupe Joumou et des commémorations de la Bataille de Vertières.',
                icone: 'public',
              },
              {
                annee: '2025',
                titre: 'Commémoration de la Bataille de Crête-À-Pierrot',
                texte: 'Rassemblement au Restaurant 1804 à Atlanta, en simultané sur toutes les plateformes FF pour commémorer l\'une des plus grandes victoires du Peuple haïtien : 800 guerriers face à 12 000 soldats français, du 2 au 24 mars 1802.',
                icone: 'star',
              },
            ].map((item, i) => (
              <div key={i} className="relative">
                {/* Point sur la timeline */}
                <div className="absolute -left-[41px] w-5 h-5 rounded-full bg-[#F5C842] border-4 border-white shadow-md"></div>

                <div className="grid grid-cols-1 md:grid-cols-[160px_1fr] gap-6 items-start">
                  {/* Année */}
                  <div>
                    <div className="font-montserrat font-black text-[#1A2E8F] text-xl">{item.annee}</div>
                    <span className="material-symbols-outlined text-[#F5C842] text-2xl mt-1">{item.icone}</span>
                  </div>
                  {/* Contenu */}
                  <div>
                    <h3 className="font-montserrat font-extrabold text-[#1C1C2E] text-lg mb-3 uppercase tracking-tight">{item.titre}</h3>
                    <p className="text-[#5A5A7A] text-sm leading-relaxed">{item.texte}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════
          NOS 8 COMITÉS — GRILLE
      ═══════════════════════════════════════════════════════════ */}
      <section className="py-28" style={{ background: C.cream }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-16">
          <div className="text-center mb-20">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="w-8 h-[3px] gold-bar rounded-full"></div>
              <span className="text-[#F5C842] font-montserrat font-bold text-xs uppercase tracking-[0.35em]">Structure opérationnelle</span>
              <div className="w-8 h-[3px] gold-bar rounded-full"></div>
            </div>
            <h2 className="font-montserrat font-black text-[#1A2E8F] uppercase mb-4" style={{ fontSize: 'clamp(32px, 5vw, 64px)', letterSpacing: '-0.02em' }}>
              Nos Comités
            </h2>
            <p className="text-[#5A5A7A] text-lg max-w-2xl mx-auto">Chaque comité est un bras opérationnel de la fondation, actif sur le terrain en Haïti et aux États-Unis.</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {comites.map((c, i) => (
              <div key={i} className="comite-card bg-white rounded-xl p-6 shadow-sm cursor-default group">
                <div className="comite-sigle font-montserrat font-black text-[#1A2E8F] text-lg mb-1 transition-colors">{c.sigle}</div>
                <div className="comite-titre font-montserrat font-bold text-[#1C1C2E] text-xs uppercase tracking-wider mb-3 transition-colors">{c.nom}</div>
                <div className="w-6 h-[2px] bg-[#F5C842] mb-3"></div>
                <p className="comite-desc text-[#5A5A7A] text-xs leading-relaxed transition-colors">{c.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════
          CTA — REJOINDRE LA FONDATION
      ═══════════════════════════════════════════════════════════ */}
      <section className="relative py-36 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1920&q=80" alt="Community" className="w-full h-full object-cover" />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(11,24,79,.94) 0%, rgba(26,46,143,.82) 100%)' }}></div>
          <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(rgba(245,200,66,.07) 1px, transparent 1px)', backgroundSize: '28px 28px' }}></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-16 text-center">
          <p className="font-script text-[#F5C842] text-4xl mb-4">Rejoignez le mouvement</p>
          <h2 className="font-montserrat font-black text-white uppercase leading-tight mb-8" style={{ fontSize: 'clamp(36px, 5.5vw, 80px)', letterSpacing: '-0.02em' }}>
            Votre acte<br />change l'avenir
          </h2>
          <p className="text-white/75 text-lg leading-relaxed max-w-2xl mx-auto mb-12">
            FONDASYON FELICITEE est une organisation 501(c)(3). Votre don est déductible des impôts et permet d'amplifier chacun de nos programmes sur le terrain en Haïti et dans la diaspora.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="inline-flex items-center gap-2 bg-[#F5C842] text-[#0D1F6E] px-10 py-4 rounded-full font-montserrat font-extrabold text-sm uppercase tracking-widest hover:bg-white transition-colors">
              <span className="material-symbols-outlined text-xl">favorite</span> Faire un don
            </Link>
            <Link to="/" className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white px-10 py-4 rounded-full font-montserrat font-extrabold text-sm uppercase tracking-widest hover:border-[#F5C842] hover:text-[#F5C842] transition-colors">
              <span className="material-symbols-outlined text-xl">handshake</span> Devenir volontaire
            </Link>
          </div>

          {/* Modes de paiement */}
          <div className="mt-12 flex flex-wrap justify-center gap-3">
            {['Zelle · +1 786-757-7866', 'PayPal', 'CashApp · $FONDASYONFELICITEE', 'MonCash · 31 30 5179', 'NatCash · 40 40 5339'].map((m, i) => (
              <span key={i} className="px-4 py-2 bg-white/10 border border-white/20 rounded-full text-white/70 text-xs font-bold font-montserrat tracking-wide">{m}</span>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════════════════════════════════════════════════
          FOOTER PREMIUM (repris du siteContent)
      ═══════════════════════════════════════════════════════════ */}
      <style>{`
        .ff-footer-p { background: linear-gradient(180deg, #0D1F6E 0%, #1A2E8F 55%, #0B184F 100%); position: relative; overflow: hidden; }
        .ff-footer-p::before { content: ''; position: absolute; inset: 0; background-image: radial-gradient(rgba(245,200,66,0.08) 1px, transparent 1px); background-size: 28px 28px; pointer-events: none; opacity: .6; }
        .ff-footer-p::after { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 1px; background: linear-gradient(90deg, transparent, #F5C842 20%, #F5C842 80%, transparent); }
        .ff-lnk { position: relative; transition: color .3s, padding-left .3s; }
        .ff-lnk:hover { color: #F5C842; padding-left: 14px; }
        .ff-soc { width:42px;height:42px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;border:1px solid rgba(245,200,66,.25);transition:all .4s;background:rgba(255,255,255,.03);}
        .ff-soc:hover{background:#F5C842;transform:translateY(-4px);}
        .ff-soc:hover .material-symbols-outlined{color:#0D1F6E!important;}
      `}</style>
      <footer className="ff-footer-p w-full text-white">
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-12 gap-10">
          <div className="col-span-2 md:col-span-4 lg:col-span-4">
            <h4 className="font-montserrat font-black text-3xl uppercase tracking-tight leading-none mb-4" style={{ background:'linear-gradient(135deg,#fff,#F5C842)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>FONDASYON<br />FELICITEE</h4>
            <p className="text-white/65 text-sm leading-relaxed mb-6 max-w-xs">Organisation à but non lucratif dédiée à la préservation de la mémoire ancestrale d'Ayiti, Haïti & USA depuis 1999.</p>
            <div className="flex gap-3 mb-4">
              {['public','photo_camera','play_circle','mail'].map((ic,i)=>(
                <a key={i} href="#" className="ff-soc"><span className="material-symbols-outlined text-[#F5C842] text-lg">{ic}</span></a>
              ))}
            </div>
            <span className="text-[10px] uppercase tracking-widest text-white/50 font-bold">501(c)(3) · USA & Haïti</span>
          </div>
          <div className="col-span-1 lg:col-span-2">
            <div className="w-6 h-0.5 mb-5" style={{ background:'linear-gradient(90deg,#F5C842,transparent)' }}></div>
            <h5 className="font-montserrat font-extrabold text-xs uppercase tracking-[0.25em] text-white mb-5">Naviguer</h5>
            <ul className="space-y-3 text-sm">
              {[['Accueil','/'],['La Fondasyon','/la-fondasyon'],['Événements','/'],['Contact','/']].map(([l,h],i)=>(
                <li key={i}><Link to={h} className="ff-lnk text-white/65 block">{l}</Link></li>
              ))}
            </ul>
          </div>
          <div className="col-span-1 lg:col-span-3">
            <div className="w-6 h-0.5 mb-5" style={{ background:'linear-gradient(90deg,#F5C842,transparent)' }}></div>
            <h5 className="font-montserrat font-extrabold text-xs uppercase tracking-[0.25em] text-white mb-5">Nos Programmes</h5>
            <ul className="space-y-3 text-sm">
              {['KOMALFA','KOMFESAY','KOMJKT','KOMRISTORICH','KOMRSL','Galerie des Aïeux'].map((p,i)=>(
                <li key={i}><a href="#" className="ff-lnk text-white/65 block">{p}</a></li>
              ))}
            </ul>
          </div>
          <div className="col-span-2 md:col-span-4 lg:col-span-3">
            <div className="w-6 h-0.5 mb-5" style={{ background:'linear-gradient(90deg,#F5C842,transparent)' }}></div>
            <h5 className="font-montserrat font-extrabold text-xs uppercase tracking-[0.25em] text-white mb-5">Nous joindre</h5>
            <ul className="space-y-4 text-sm">
              {[['location_on','Port-au-Prince, Haïti'],['mail','info@fondasyonfelicitee.com'],['call','+1 786-757-7866']].map(([ic,t],i)=>(
                <li key={i} className="flex items-center gap-3"><span className="material-symbols-outlined text-[#F5C842] text-lg">{ic}</span><span className="text-white/65">{t}</span></li>
              ))}
            </ul>
          </div>
        </div>
        <div className="relative z-10 border-t border-white/10 bg-black/20">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex flex-col md:flex-row items-center gap-3 justify-between text-xs">
            <p className="text-white/45">© 2026 <span className="text-white font-bold">FONDASYON FELICITEE</span> — Tous droits réservés · Honorer le passé, bâtir l'avenir.</p>
            <div className="flex items-center gap-5 text-white/45">
              {['Mentions légales','Confidentialité','Conditions'].map((l,i)=>(
                <a key={i} href="#" className="hover:text-[#F5C842] transition-colors">{l}</a>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
